import { flagColor, flagLabel, flagShort, type StudentFlagDef } from '@td/shared';

/**
 * A flag chip in the flag's own colour.
 *
 * The colour is a teacher-chosen hex, so the text can't be a fixed Tailwind
 * class — the background is tinted and the label uses the full colour, which
 * stays readable across the whole Boho palette without needing contrast maths
 * per flag.
 */
export function FlagBadge({
  flagKey,
  defs,
  full = false,
}: {
  flagKey: string;
  defs?: StudentFlagDef[];
  full?: boolean;
}) {
  const color = flagColor(flagKey, defs);
  return (
    <span
      title={flagLabel(flagKey, defs)}
      className="rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wide"
      style={{ backgroundColor: `${color}2E`, color }}
    >
      {full ? flagLabel(flagKey, defs) : flagShort(flagKey, defs)}
    </span>
  );
}
